import {AppState} from '../reducerType';
import {DeleteAccountRequestStatus} from '../../actions/cde/cdeTypes';

export const selectDeleteAccountStatus = (state: AppState): DeleteAccountRequestStatus | null => state.cde.deleteAccountStatus;